<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="frontmatter">
<div class="bodymatter" epub:type="bodymatter">
<section epub:type="division" id="fm1">
<div class="dis_imgbdyb"><a id="page6"></a><img alt="" id="img001" src="Images/9781618372475_001.jpg"/></div>
<p class="credit"><span class="hlink" href="#/Text/9781618372475_crd#img001a" title="Link target outside of Sample">Credit 1</span></p>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781618372475_fm1.vue?68bcd15a